<template>
  <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    @load-end="onLoadEnd"
    @error="onRequestError">

    <h1 class="text-center">A rotina do seu filho também faz parte da nossa.</h1>
    <v-divider class="divider-accent my-4" />

    <v-form @submit.prevent="handleUpdateTab" id="tab-form">

      <v-card>
        <v-flex pa-4 mb-4>
          <child-routine />
        </v-flex>
      </v-card>

      <v-card>
        <v-flex pa-4 mb-4>
          <father-routine />
        </v-flex>
      </v-card>

      <v-card>
        <v-flex pa-4>
          <mother-routine />
        </v-flex>
      </v-card>

    </v-form>

    <alert-modal
      :visibility="declarationModalVisibility"
      title="Confirmação de dados"
      :message="declarationMessage"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="onDeclarationModal"
      @cancel="closeDeclarationModal" />

  </load-form-handler>
</template>

<script>
import FatherRoutine from './FormFatherRoutine'
import MotherRoutine from './FormMotherRoutine'
import ChildRoutine from './FormChildRoutine'
import LoadFormHandler from '@/components/LoadFormHandler'
import * as api from '@/api'
import AlertModal from '@/components/AlertModal'
import { message, formTabs, declaration, tab } from '@/mixins'

/**
 * @group Form
 * Componente de form para dados da Rotina da Mãe e Pai
 */
export default {
  name: 'FormRoutine',

  components: {
    FatherRoutine,
    MotherRoutine,
    ChildRoutine,
    LoadFormHandler,
    AlertModal
  },

  data: () => ({
    isFormLoading: true,
    resource: {}
  }),

  mixins: [message, formTabs, declaration, tab],

  provide () {
    const resource = {}
    Object.defineProperty(resource, 'form', {
      enumerable: true,
      get: () => this.resource
    })
    return { resource }
  },

  methods: {
    getTabPromise () {
      return api.forms.dailyRoutine.get(this.currentStudentId)
    },

    /**
     * @vuese
     * Método para atualizacao de dados da aba
     */
    handleUpdateTab () {
      this.openDeclarationModal()
    },

    onDeclarationModal () {
      api.forms.dailyRoutine.update(this.currentStudentId, this.resource)
        .then(response => {
          this.resource = response.data
          this.showMessageByType(this.messageTypes.MODIFIED)
        }).catch(this.handleErrorMessage)
        .finally(this.closeDeclarationModal)
    }
  }
}
</script>
